import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import banner from "../assets/banner.jpg";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function Shop() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [subCategoryData, setsubCategoryData] = useState([]);
    const [sizeData, setSizeData] = useState([]);
    const [ageData, setAgeData] = useState([]);
    const [productData, setProductData] = useState([]);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    useEffect(() => {
        fetchCategoryData();
        fetchAllProductData();
    }, []);
    const fetchCategoryData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "maincategories";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "subcategories";
            const response = await makeRequest("get", url);
            if (response) {
                setsubCategoryData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "sizes";
            const response = await makeRequest("get", url);
            if (response) {
                setSizeData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "ages";
            const response = await makeRequest("get", url);
            if (response) {
                setAgeData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchAllProductData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "product";
            const response = await makeRequest("get", url);
            if (response) {
                setProductData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <Header />
            <div className="heros">
                <img src={banner} alt="Banner" className="heros-img" />
            </div>
            <div className="category-containers">
                {dataSource?.map((item, index) => (
                    <div key={index}
                        className={`category-card ${selectedIndex === index ? "active" : ""}`}
                        onClick={() =>  setSelectedIndex(selectedIndex === index ? null : index)}>
                        <img src={item?.image_url} alt={item?.maincategory_name} />
                        <span>{item.maincategory_name}</span>
                    </div>
                ))}
            </div>
            <div className="shop-layout">
                <aside className="filter">
                    <h3>Filters</h3>
                    <div className="filter-group">
                        <p>Sub Category</p>
                        {subCategoryData?.map((item, index) => (
                            <div key={index}>
                                <label><input type="checkbox" /> {item.subcategory_name}</label>
                            </div>
                        ))}
                    </div>
                    <div className="filter-group">
                        <p>Size</p>
                        <div className="sizes">
                            {sizeData?.map((item, index) => (
                                <span key={index}
                                    className={selectedSize === item.size_name ? "active" : ""}
                                    onClick={() => setSelectedSize(item.size_name)}>
                                    {item.size_name}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className="filter-group">
                        <p>Size</p>
                        <div className="sizes">
                            {ageData?.map((item, index) => (
                                <span key={index}
                                    className={selectedSize === item.age_name ? "active" : ""}
                                    onClick={() => setSelectedSize(item.age_name)}>
                                    {item.age_name}
                                </span>
                            ))}
                        </div>
                    </div>
                </aside>
                <section className="product">
                    {productData?.map((p) => (
                        <div key={p.id} className="prod-card">
                            <img src={p?.product_main_image} alt={p?.product_name} />
                            <h4>{p?.product_name}</h4>
                            {/* <div className="prod-price">
                                {p?.product_mrp_price > 0 &&
                                    <span className="prod-mrp">₹{p?.product_mrp_price}</span>
                                }
                                <span className="prod-sale">₹{p?.product_sales_price}</span>
                            </div> */}
                            <div className="rating">⭐⭐⭐⭐⭐</div>
                            {/* <button>Add to Cart</button> */}
                        </div>
                    ))}
                </section>
            </div>
            <Footer />
        </div>
    )
}
